import { ContentInfoPanel } from "@dropbox/dash-component-library";
import { Box } from "@dropbox/dig-foundations";
import type { TypeaheadResult } from "@mirage/mosaics/SearchBarWithTypeahead/useConvertToTypeaheadResults";
import { useTheme } from "@mirage/service-settings/theming/useTheme";
import { getTypeaheadResultInfo } from "./getTypeaheadResultInfo";

export const TypeaheadInfoPanel = ({ result }: { result: TypeaheadResult }) => {
  const isDarkMode = useTheme();
  const resultInfo = getTypeaheadResultInfo(result, isDarkMode);

  return (
    <Box
      width="100%"
      height="100%"
      borderTop="Solid"
      borderLeft="Solid"
      borderColor="Border Subtle"
      borderWidth="1"
    >
      <ContentInfoPanel {...resultInfo} />
    </Box>
  );
};
